import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzzurroTable, CopyToClipboardModule, SimpleButtonComponent, SimpleInputComponent, TitleContentComponent } from 'ngx-zcs-components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { IonicModule } from '@ionic/angular';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { DeviceRegistryComponent } from './device-registry.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { DeviceRegistryService } from './device-registry.service';

@NgModule({
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    CopyToClipboardModule,
    FormsModule,
    IonicModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    SimpleButtonComponent,
    SimpleInputComponent,
    TitleContentComponent,
  ],
  declarations: [DeviceRegistryComponent],
  exports: [DeviceRegistryComponent],
  providers: [
    DeviceRegistryService,
  ],
})
export class DeviceRegistryComponentModule {}
